import { styled } from "@mui/material/styles"
import { Typography } from "@mui/material"

export const StyledTypographyGrey = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500]
}))